import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.filterButton = document.querySelector("[data-filterby]")
    this.allItems = document.querySelectorAll('.services-post')
  }

  filterCategory(event) {
    event.preventDefault();
    let filterdCategory = event.currentTarget.dataset.filterby;
    if (filterdCategory === 'all') {
      this.allItems.forEach(function(item){
        item.classList.remove('hidden');
      })
      return;
    }

    this.allItems.forEach(function(item){
      let categories = item.dataset.category
      categories = JSON.parse(categories);
      let hasCategory = categories.indexOf(filterdCategory) > -1;

      if (!hasCategory) {
        item.classList.add('hidden');
      } else {
        item.classList.remove('hidden');
      }
    })
  }
}
